import React from "react";
import Integrations from "../../views/clientView/integrations";

export default function IntegrationsPage() {
    return <Integrations />
}